import React from "react";
import { Button } from "components/bootstrap";
import { LinkContainer, Spinner } from "components/common";
import useRunWorkflow from "aiagent/AgentWorkflows/hooks/useRunWorkflow";
import AgentWorkflowRoutes from "aiagent/Routes";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import usePermissions from "hooks/usePermissions";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
const runButtonTitle = (workflowTitle, hasConfig, aiDisabled) => {
  if (aiDisabled) {
    return "AI features are disabled by the administrator.";
  }
  return hasConfig ? `Run ${workflowTitle} workflow` : "Set up a provider configuration to run this workflow.";
};
const RunWorkflowButton = ({ workflow, onSuccess }) => {
  const sendTelemetry = useSendTelemetry();
  const { isPermitted } = usePermissions();
  const { mutate, isPending } = useRunWorkflow({ type: workflow.id, title: workflow.title, onSuccess });
  const {
    data: { isEnabled: aiEnabled },
    isLoading: isLoadingAIConfiguration
  } = useAIConfiguration();
  const runWorkflow = (event) => {
    event.stopPropagation();
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.WORKFLOW_RUN_TRIGGERED, {
      app_section: "aiagent-workflows",
      event_details: { workflow_type: workflow.id }
    });
    mutate();
  };
  if (workflow.active_run_id) {
    if (isPermitted("agent_workflow:debug")) {
      return /* @__PURE__ */ React.createElement(LinkContainer, { to: AgentWorkflowRoutes.runDetails(workflow.active_run_id) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", title: `A run of ${workflow.title} is in progress. View it.` }, /* @__PURE__ */ React.createElement(Spinner, { text: "View run", delay: 0 })));
    }
    return /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", disabled: true, title: `A run of ${workflow.title} is already in progress.` }, /* @__PURE__ */ React.createElement(Spinner, { text: "Running\u2026", delay: 0 }));
  }
  const hasConfig = !!((workflow == null ? void 0 : workflow.model) && (workflow == null ? void 0 : workflow.provider));
  const aiDisabled = !isLoadingAIConfiguration && !aiEnabled;
  const title = runButtonTitle(workflow.title, hasConfig, aiDisabled);
  return /* @__PURE__ */ React.createElement(Button, { title, bsStyle: "success", disabled: isPending || !hasConfig || aiDisabled, onClick: runWorkflow }, isPending ? "Starting\u2026" : "Run Workflow");
};
export default RunWorkflowButton;
